// extracted by mini-css-extract-plugin
export default {"main":"FormaContactoSelector_main__4sVXP"};